<template>
  <div>
    <v-table
      :url="affiliateUrl"
      :attributes="[
        {
          attribute: 'description',
          name: 'Beschreibung'
        },
        {
          attribute: 'slug',
          name: 'Trackingcode',
          type: 'CopyClipboardCell'
        },
        {
          attribute: 'partner',
          name: 'Werbepartner'
        },
        {
          attribute: 'quota',
          name: 'Kontingent'
        },
        {
          attribute: 'cpm',
          name: 'TKP',
          type: 'CurrencyCell'
        },
        {
          attribute: 'cpl',
          name: 'CPL',
          type: 'CurrencyCell'
        },
        {
          attribute: 'oi_today',
          name: 'Mitglieder heute'
        },
        {
          attribute: 'oi_total',
          name: 'Mitglieder gesamt'
        },
        {
          attribute: 'page_visits',
          name: 'Seitenaufrufe Heute / Gesamt'
        },
        {
          attribute: 'type',
          name: 'SOI / DOI'
        }
      ]"
      ref="affiliate"
    ></v-table>

    <v-table
      :url="userUrl"
      :attributes="[
        {
          attribute: 'censored_membername',
          name: 'Name'
        },
        {
          attribute: 'censored_email',
          name: 'Email-Provider'
        },
        {
          attribute: 'pivot.created_at',
          type: 'DateTimeCell',
          name: 'Registriert'
        },
        {
          attribute: 'additional_affiliate_parameter.parameters',
          type: 'ModalCell',
          modal: 'PublicAffiliateParametersModal',
          mode: 'additionalParameters',
          name: 'Übergebene Parameter'
        }
      ]"
    ></v-table>
  </div>
</template>

<script lang="babel">
export default {
  computed: {
    affiliateUrl() {
      return `/api/v1/affiliatePublic/${this.$route.params.slug}`;
    },
    userUrl() {
      return `/api/v1/affiliatePublicUser/${this.$route.params.slug}`;
    }
  }
}
</script>
